import { useApiClient } from '@m43/core';
import { useQuery } from '@tanstack/react-query';
import { CadSearchResource, UnitStatusSearchForm } from '@mark43/cad-api';
import { useHandleSearchResponse } from '../search-windows/use-handle-search-response';
import { useUnitStatusSearchResultsPaginationContext } from './unit-status-search-results-pagination-provider';
import { useUnitStatusSearchSortContext } from './unit-status-search-sort-provider';

export function useSearchUnitStatusesQuery(
    tabId: number,
    unitStatusSearchForm: UnitStatusSearchForm,
    savedSearchId?: number
) {
    const pagination = useUnitStatusSearchResultsPaginationContext();
    const sort = useUnitStatusSearchSortContext();
    const apiClient = useApiClient();
    const handleSearchResponse = useHandleSearchResponse(pagination);
    return useQuery(
        [
            'unit-status-search-results',
            tabId,
            pagination.itemOffset,
            pagination.itemsPerPage,
            sort.sortByValue.value,
            sort.directionValue.value,
        ] as const,
        ({ queryKey }) => {
            return apiClient
                .request<CadSearchResource.UnitStatusSearch>({
                    method: 'POST',
                    url: 'cad_search/unit_status',
                    data: {
                        unitStatusSearchForm,
                        from: queryKey[2],
                        size: queryKey[3],
                        sortKey: queryKey[4],
                        sortType: queryKey[5],
                    },
                })
                .then((resp) => {
                    const unitStatusSearchResponse = resp.data.data;
                    handleSearchResponse(unitStatusSearchResponse?.totalCount ?? 0, queryKey[2]);
                    return unitStatusSearchResponse;
                });
        },
        {
            enabled: !savedSearchId,
        }
    );
}
